import React from 'react';
// down
export default ({ className, ...other }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    {...other}
    className={`icon w16 w-16 ${className || ''}`}
  >
    <g id="Group_564" data-name="Group 564" transform="translate(-1523 -1284)">
      <g
        id="Ellipse_25"
        data-name="Ellipse 25"
        transform="translate(1523 1284)"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
      >
        <circle cx="8" cy="8" r="8" stroke="none" />
        <circle cx="8" cy="8" r="7.5" fill="none" />
      </g>
      <g
        id="Group_453"
        data-name="Group 453"
        transform="translate(1527.328 1289.294)"
      >
        <line
          id="Line_49"
          data-name="Line 49"
          x1="7.087"
          transform="translate(0 2.835)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_50"
          data-name="Line 50"
          x1="2.835"
          y2="2.835"
          transform="translate(4.252 2.835)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <line
          id="Line_51"
          data-name="Line 51"
          x1="2.835"
          y1="2.835"
          transform="translate(4.252)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
/>;
